import React from "react";

const FinishedScreen = () => {
  return (
    <div className="medium-width">
      <p>
        Hooray, you finished!
      </p>
    </div>
  )
}

export default FinishedScreen;
